import { DateTime } from 'luxon';

export const getBudgetDateRange = (year: number, month: number) => {
  const startDate = DateTime.fromObject({ year, month });
  const endDate = startDate.endOf('month');

  return { startDate, endDate };
};

